import React from "react";

import {
  ArrowLeft,
  Landmark,
  Globe2,
  ShieldCheck,
  Smartphone,
  BadgeDollarSign,
  Wallet,
  CheckCircle2,
  ArrowRight,
  Download,
} from "lucide-react";

import "../Styles/Business.css";

import { useNavigate }
from "react-router-dom";

const services = [

  {
    icon: Globe2,
    title: "International Transfers",
    desc:
      "Reliable MoneyGram transfer services worldwide.",
  },

  {
    icon: Wallet,
    title: "Local Transfers",
    desc:
      "Fast and convenient local money transfer solutions.",
  },

  {
    icon: Landmark,
    title: "Government Payments",
    desc:
      "Senior pension and public assistance services.",
  },

  {
    icon: Smartphone,
    title: "Digital Transactions",
    desc:
      "Manage transfers and payments using the WIDIT App.",
  },

];

const Business = () => {

  const navigate =
    useNavigate();

  return (

    <div className="modern-business-page">

      {/* HERO */}
      <section className="modern-business-hero">

        <div className="modern-business-overlay" />

        <div className="modern-business-content">

          <button
            className="modern-business-back-btn"
            onClick={() =>
              navigate("/services")
            }
          >

            <ArrowLeft size={18} />
            Back To Services

          </button>

          <div className="modern-business-badge">
            MONEYGRAM & WIDIT SERVICES
          </div>

          <h1 className="modern-business-heading">
            Trusted Money
            <span> Transfer Solutions.</span>
          </h1>

          <p className="modern-business-text">
            RCS is the only MoneyGram
            agent in the vicinity of
            Wakenaam, providing reliable
            local and international money
            transfer solutions alongside
            government payment services.
          </p>

        </div>

      </section>

      {/* HIGHLIGHTS */}
      <section className="modern-business-highlights">

        {services.map(
          (service, index) => {

          const Icon =
            service.icon;

          return (

            <div
              className="modern-business-highlight-card"
              key={index}
            >

              <div className="modern-business-icon">
                <Icon size={32} />
              </div>

              <h3>
                {service.title}
              </h3>

              <p>
                {service.desc}
              </p>

            </div>
          );
        })}

      </section>

      {/* MAIN */}
      <section className="modern-business-main">

        {/* LEFT */}
        <div className="modern-business-card">

          <div className="modern-business-card-header">

            <div className="modern-business-header-icon">

              <BadgeDollarSign size={30} />

            </div>

            <div>

              <h2>
                MoneyGram Services
              </h2>

              <p>
                Local and international
                transfer solutions.
              </p>

            </div>

          </div>

          <p className="modern-business-paragraph">

            RCS proudly serves as the
            only MoneyGram agent in
            the vicinity of Wakenaam,
            offering secure and reliable
            international and local
            money transfer services.

          </p>

          <div className="modern-business-note">

            <h3>
              Government Payment Services
            </h3>

            <p>
              Authorized by WIDIT Bill
              Payment Services
              (Massy Remittance Guyana),
              RCS facilitates Senior Pension
              and Public Assistance payments
              every working day.
            </p>

          </div>

        </div>

        {/* RIGHT */}
        <div className="modern-business-card">

          <div className="modern-business-card-header">

            <div className="modern-business-header-icon green">

              <ShieldCheck size={30} />

            </div>

            <div>

              <h2>
                Did You Know?
              </h2>

              <p>
                Convenient pension access.
              </p>

            </div>

          </div>

          <div className="modern-business-alert">

            <CheckCircle2 size={20} />

            You can collect your Senior
            Pension and Public Assistance
            payments any day of the Week!

          </div>

          <div className="modern-business-alert">

            <CheckCircle2 size={20} />

            Payments are made on the 1st working day, regardless of weekday or weekends!

          </div>

          {/* APP */}
          <div className="modern-app-section">

            <div className="modern-app-header">

              <div className="modern-app-icon">

                <Smartphone size={28} />

              </div>

              <div>

                <h3>
                  Download The WIDIT App
                </h3>

                <p>
                  Manage transactions at
                  your convenience.
                </p>

              </div>

            </div>

            <p className="modern-app-text">

              Initiate your MoneyGram
              transactions directly from
              the official WIDIT App and
              confirm them in-store at RCS.

            </p>

            <div className="modern-app-buttons">

              <a
href="https://play.google.com/store/apps/details?id=net.controlmoney.massyremittancedigital&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="modern-app-btn"
              >

                <Download size={18} />

                Android

                <ArrowRight size={16} />

              </a>

              <a
href="https://apps.apple.com/gy/app/widit/id6479331820"
                target="_blank"
                rel="noopener noreferrer"
                className="modern-app-btn"
              >

                <Download size={18} />

                iPhone

                <ArrowRight size={16} />

              </a>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default Business;